import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    white: '#fff',
    white2: '#f5f5f5',
    white3: '#f0f0f0',
    blueGerdau: '#003366',
    lightBlue: '#40a9ff',
    lightBlue2: '#CCE5F2',
    lightBlue3: '#DCE9FF',
    blue: '#1890FF',
    blue2: '#87b6e0',
    blue3: '#3399CC',
    blue4: '#0578BE',
    blue5: '#1756EF',
    blue6: '#0069AC',
    blue7: '#99BfD7',
    blue8: '#01416B',
    darkBlue: '#002D53',
    darkBlue2: '#244577',
    iceBlue: '#edf2f6',
    waterBlue: '#ecf2f6',
    statusBlue: '#395586',
    disabledGray: 'rgba(176, 188, 206, 1)',
    gray1: '#fafafa',
    gray2: '#eff2f3',
    gray3: '#ddd',
    gray4: '#d6d6d6',
    gray5: '#bebebe',
    gray6: '#DCDCDC',
    gray7: '#eee',
    gray8: '#EFEFEF',
    grayDark: '#595e69',
    grayDark2: '#484848',
    grayDark3: '#495961',
    grayDark4: '#414E55',
    grayLight: '#EFEFEF',
    graySubTitle: '#757575',
    grayAntdBorder: '#d9d9d9',
    grayHefestoBorder: '#B0B0B0',
    neutralsGray: '#192D38',
    grayStatus: '#939494',

    green: '#02BD10',
    green2: '#93c175',
    green3: '#99CC68',
    green4: '#366a11',
    green5: '#008746',
    greenLight: '#F6FFED',
    statusGreen: '#477237',
    red: '#F8292E',
    red2: '#C74A34',
    red3: '#9a2a1c',
    red4: '#E40E68',
    red5: '#FFA39E',
    redLight: '#FFE2DC',

    orange: '#FBAD14',
    orange2: '#E5A812',
    statusOrange: '#E17915',
    yellow: '#ffe598',
    lightYellow: '#FFF5CC',
    beige: '#f6be98',
    black: '#000000',
    purple: '#874487',
    purple2: '#7C3E80',
    overlay: 'rgba(25, 45, 56, 0.5)',

    chipPending: '#DDDDDD',
    chipCancelled: ' #C74A34',
    chipDelivery: '#C17915',
    chipShipment: '#4091F7',
    chipbBilled: '#55B839',

    lightGray: '#C8C8C8',
    lightGray2: '#c2c4c5',
    lightGray3: '#c4c4c4',
    lightGray4: '#DEE8EF',
    lightGray5: '#5D6569',

    white4: '#FFFFFF'
  },

  fonts: {
    openSans: '"Open Sans", sans-serif',
    workSans: '"Work Sans", sans-serif'
  },

  commoms: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    boxShadow2: '0 2px 4px 0 rgba(0, 0, 0, 0.1), 2px 0 4px 0 rgba(0, 0, 0, 0.1)'
  },

  breakpoints: {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '890px',
    laptopM: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
  }
};

export default theme;
